import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const UniformShop = () => {
    useEffect(() => {
        document.title = 'Uniform Shop -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Facilities  </li>
                 <li>Other Facilities</li>
                 <li>Uniform Shop</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Uniform Shop </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <p>The School uniform is to be bought from the school uniform store. The uniform purchased from the school store conforms to the standards set by the school. The House T-Shirts are also available at this store. All articles of the uniform are to be bought well in advance. Students will not be allowed to leave their classes to buy their uniform. Students may, however, visit the store during the break.</p>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default UniformShop